var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    stroke: "#A0A0A0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000020_7826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3448 3.65869H5.11754C4.64057 3.65869 4.25391 4.04535 4.25391 4.52233V18.3405C4.25391 18.8175 4.64057 19.2041 5.11754 19.2041H16.3448C16.8218 19.2041 17.2085 18.8175 17.2085 18.3405V4.52233C17.2085 4.04535 16.8218 3.65869 16.3448 3.65869Z",
    strokeWidth: 1.72727,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14391 1.93164V4.52255M13.3257 1.93164V4.52255M7.28027 8.40891H14.1894M7.28027 11.8635H12.4621M7.28027 15.318H10.7348",
    strokeWidth: 1.72727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000020_7826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7273,
    height: 20.7273,
    fill: "white",
    transform: "translate(0.364258 0.20459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.4d85034eae80ce3c296c41c981771d9f.svg";
export { ForwardRef as ReactComponent };